import React from 'react';
import Dropzone from 'react-dropzone-uploader';
import 'react-dropzone-uploader/dist/styles.css';
import { func, number, string } from 'prop-types';
import ImmediateFileUploaderCustomPreview from './ImmediateFileUploaderCustomPreview';
import ImmediateFileUploaderCustomInput from './ImmediateFileUploaderCustomInput';
import ImmediateFileUploaderCustomLayout from './ImmediateFileUploaderCustomLayout';

const ImmediateFileUploader = ({ uploadUrl, maxFiles, maxSizeBytes, onFilesChanged, accept, onDeleteUploadedFile }) => {
  // specify upload params and url for your files
  const getUploadParams = () => ({ url: uploadUrl, withCredentials: true });

  // called every time a file's `status` changes
  const handleChangeStatus = (file, status, allFiles) => {
    const fileInfos = allFiles
      .filter(fileWithMeta => fileWithMeta.meta.status !== 'removed')
      .map(fileWithMeta => {
        const r = { fileId: null };
        r.uploaded = fileWithMeta.meta.status === 'done';
        if (r.uploaded) {
          const response = JSON.parse(fileWithMeta.xhr.response);
          r.fileId = response.fileId;
          r.fileName = fileWithMeta.meta.name;
          r.fileType = fileWithMeta.meta.type;
          r.fileSize = fileWithMeta.meta.size;
          return r;
        }

        if (['preparing', 'getting_upload_params', 'uploading', 'headers_received'].includes(fileWithMeta.meta.status)) {
          r.inProgress = true;
        } else {
          r.failed = true;
        }

        return r;
      });

    onFilesChanged(fileInfos);
    if (status === 'removed' && file.xhr) {
      const fileResponse = JSON.parse(file.xhr.response);
      onDeleteUploadedFile(fileResponse.fileId);
    }
  };

  return (<Dropzone
    getUploadParams={getUploadParams}
    onChangeStatus={handleChangeStatus}
    maxFiles={maxFiles}
    maxSizeBytes={maxSizeBytes}
    inputContent={null}
    inputWithFilesContent={null}
    SubmitButtonComponent={null}
    PreviewComponent={props => <ImmediateFileUploaderCustomPreview {...props} />}
    InputComponent={props => <ImmediateFileUploaderCustomInput {...props} />}
    LayoutComponent={props => <ImmediateFileUploaderCustomLayout {...props} />}
    accept={accept}
  />);
};

ImmediateFileUploader.propTypes = {
  uploadUrl: string.isRequired,
  maxFiles: number.isRequired,
  maxSizeBytes: number.isRequired,
  onFilesChanged: func.isRequired,
  onDeleteUploadedFile: func.isRequired,
  accept: string,
};

export default ImmediateFileUploader;



// WEBPACK FOOTER //
// ./src/components/common/ImmediateFileUploader.js